export const auth = {
  loggedOut: "You're logged out",
  notIntentional: "If this wasn't your intention, ",
  loginAgain: 'log in again',
};
